"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Subtitle = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../../styles/index.js");
var _index2 = require("../Text/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Subtitle = exports.Subtitle = (0, _styledComponents["default"])(_index2.Text).attrs({
  semanticColor: 'textSubdued',
  variant: 'bodyMedium'
}).withConfig({
  displayName: "Subtitle",
  componentId: "sc-phhz2w-0"
})(["display:block;margin-block-start:", ";@media (min-width:", "){text-align:center;}"], (0, _index.cssSpacing)('tighter-2', '8px'), _encoreFoundation.screenSmMin);